import React, { useState, useEffect } from 'react';
import css from './GlobalTable.less';
import _ from 'lodash';
import GlobalPagination from '../../components/StyledPagination/GlobalPagination';
import Query from 'src/constrains/Query/Query';

import Table from '@/src/components/EditableTable/EditableTable';
import BulkEditor from '@/src/components/BulkEditor/BulkEditor';
import Selector from 'src/components/TableColSelector/ColSelector';
interface IProps {
  columns;
  dataSource;
  pagination?;
  id: string;
  onRow?: any;
  hideHeader?: boolean; //不展示table上方的设置和多选展示及批量操作
  hideRowSelection?: boolean;
  hidePagination?: boolean;
  disableSelectButton?: boolean; //是否隐藏Bulk Edit按钮
  buttonMenu?; //配置Bulk Edit
  expandable?;
  current?;
  pageSize?;
  setCurrent?;
  setPageSize?;
  total?;
  rowKey?;
  setSelectedAll?;
  // rowSelection?;
  rowSelection?;
  selectedRowKeys?;
  mappedSelectedKeys?;
  loading?;
  queryProps?;
  allProductsUuid?;
  hideQuery?;
  addFun?;
  addText?;
  rowDeleteFunc?;
  selectedAll?;
  className?;
  totalText?: string;
  handleTableSettingChange?; //redux中保存的配置table columns的action,如不需缓存则不需要传
  tableSettings?; //redux中保存的配置table columns的key,不传则默认为展示state中的数据
  onChange?;
}
const GlobalTable = (props: IProps) => {
  const {
    columns, //宽度和minWidth不能用%！
    dataSource,
    // disableSelectButton,
    buttonMenu,
    pagination = {},
    id,
    hideRowSelection,
    hideHeader,
    hidePagination,
    expandable,
    current,
    pageSize,
    setCurrent,
    setPageSize,
    total,
    loading,
    rowKey,
    rowSelection = {},
    selectedRowKeys,
    mappedSelectedKeys,
    queryProps,

    hideQuery,
    totalText,
    selectedAll,
    setSelectedAll,
    className,
    handleTableSettingChange,
    tableSettings,
    ...rest
  } = props;

  const [allColumns, setAllColumns] = useState([]);
  const saveColumns = (tableSettings || []).length
    ? allColumns.map((o) => {
        if (tableSettings.includes(o.key)) {
          o.default = true;
        } else {
          o.default = false;
        }
        return o;
      })
    : [];
  const showSet = allColumns.filter((column) => column.optional);

  const handleColumnsChange = (columnArray) => {
    setAllColumns(columnArray);
    const allColumnsKey = columnArray.map((column) => {
      if (column.default) {
        return column.key;
      }
    });
    if (handleTableSettingChange) handleTableSettingChange(allColumnsKey);
  };

  const onChange = (col = []) => {
    handleColumnsChange(col);
  };
  const pageOnChange = (page, pageSize) => {
    setCurrent(page - 1);
  };
  const pageSizeChange = (value) => {
    setPageSize(value.value);
    setCurrent(0);
  };
  useEffect(() => {
    const columnArray = _.cloneDeep(columns || []);
    setAllColumns(columnArray);
  }, [columns]);

  //选择全部
  const selectAll = () => {
    //TODO:选择全部待确认，是否需要从后端拿到全部的uuid
    const allSelect = dataSource.map((item) => {
      return item.uuid;
    });
    if (setSelectedAll) setSelectedAll(true);
    rowSelection.onChange(allSelect);
  };
  //重置设置
  const setReset = () => {
    handleColumnsChange(columns);
  };
  //配置每页展示条数
  const pageSizeOption = [20, 60, 100];

  return (
    <React.Fragment>
      {!hideQuery && <Query {...queryProps} />}

      {/* {(queryProps.searchListArray.length > 0 ||
        queryProps.filter.length > 0) &&
        !dataSource.length && <TableNoData />} */}
      {dataSource.length && !hideHeader ? (
        <div className={css.tableHeader}>
          <BulkEditor
            selectAll={selectAll}
            selectedAll={selectedAll}
            buttonMenu={buttonMenu}
            total={total}
            dataSource={dataSource}
            selectedRowKeys={selectedRowKeys} //mappedSelectedKeys}
            allSelected={mappedSelectedKeys}
          />
          {showSet.length > 0 && (
            <Selector
              allColumns={saveColumns.length > 0 ? saveColumns : allColumns}
              onChange={onChange}
              setReset={setReset}
            />
          )}
        </div>
      ) : (
        ''
      )}

      <Table
        id={id}
        // className={css.globalTable}
        columns={allColumns}
        dataSource={dataSource}
        className={className}
        rowKey={rowKey}
        pagination={false}
        expandable={expandable}
        {...(!hideRowSelection && { rowSelection })}
        loading={loading}
        {...rest}
      />

      {!hidePagination ? (
        <GlobalPagination
          pageOnChange={pageOnChange}
          totalText={totalText}
          pageSize={pageSize}
          pageSizeOption={pageSizeOption}
          pageSizeChange={pageSizeChange}
          total={total}
          current={current + 1}
          paginationProps={pagination}
          pageSizeWidth={120}
          setCurrent={setCurrent}
        />
      ) : (
        ''
      )}
    </React.Fragment>
  );
};
export default GlobalTable;
